/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export function fixProductVariantSpacing(variantNumber: string) {
  return variantNumber.replaceAll(" ", "").replaceAll(":", " : ").trim();
}
